import React, { useEffect, useState } from 'react';
import './Dice.css';

export default function Dice({ value = 1, rolling = false }) {
  const [rotation, setRotation] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (rolling) {
      const interval = setInterval(() => {
        setRotation({
          x: Math.floor(Math.random() * 4) * 90 + 360,
          y: Math.floor(Math.random() * 4) * 90 + 360
        });
      }, 120);
      return () => clearInterval(interval);
    } else {
      let finalX = 0;
      let finalY = 0;
      switch (value) {
        case 1: finalX = 0; finalY = 0; break;
        case 2: finalX = 0; finalY = -90; break;
        case 3: finalX = 0; finalY = 90; break;
        case 4: finalX = -90; finalY = 0; break;
        case 5: finalX = 90; finalY = 0; break;
        case 6: finalX = 180; finalY = 0; break;
        default: finalX = 0; finalY = 0; break;
      }
      setRotation({ x: finalX, y: finalY });
    }
  }, [rolling, value]);

  return (
    <div className="dice-container">
      <div 
        className={`dice ${rolling ? 'rolling' : ''}`}
        style={{ transform: `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)` }}
      >
        {/* Face 1 */}
        <div className="face face-1">
          <span className="pip red-pip center-pip"></span>
        </div>
        {/* Face 2 */}
        <div className="face face-2">
          <span className="pip top-left"></span>
          <span className="pip bottom-right"></span>
        </div>
        {/* Face 3 */}
        <div className="face face-3">
          <span className="pip top-left"></span>
          <span className="pip center-pip"></span>
          <span className="pip bottom-right"></span>
        </div>
        {/* Face 4 */}
        <div className="face face-4">
          <span className="pip top-left"></span>
          <span className="pip top-right"></span>
          <span className="pip bottom-left"></span>
          <span className="pip bottom-right"></span>
        </div>
        {/* Face 5 */}
        <div className="face face-5">
          <span className="pip top-left"></span>
          <span className="pip top-right"></span>
          <span className="pip center-pip"></span>
          <span className="pip bottom-left"></span>
          <span className="pip bottom-right"></span>
        </div>
        {/* Face 6 */}
        <div className="face face-6">
          <span className="pip top-left"></span>
          <span className="pip top-right"></span>
          <span className="pip center-left"></span>
          <span className="pip center-right"></span>
          <span className="pip bottom-left"></span>
          <span className="pip bottom-right"></span>
        </div>
      </div>
    </div>
  );
}
